<script>
import baseMixin from '@/mixins/baseMixin'
import ColorSet from '@/models/general/colorSet'
import VuetifyColourClass from '@/constants/core/VuetifyColourClass'
import CommentBaseAvatar from './comment-base-avatar.vue'

import CommentBaseSubtitle from './comment-base-subtitle.vue'

export default {
  name: 'CommentBase',
  components: { CommentBaseAvatar, CommentBaseSubtitle },
  mixins: [baseMixin],
  props: {
    hideAvatar: {
      type: Boolean,
    },
    addedBy: {
      type: String,
      default: '',
    },
    avatarIcon: {
      type: String,
      default: '',
    },
    avatarColor: {
      type: ColorSet,
      default: () => null,
    },
    text: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    disableHover: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
    color: {
      type: String,
      default: VuetifyColourClass.grey,
    },
    activeClass: {
      type: String,
      default: '',
    },
    hoverClass: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    colorClassModifier() {
      return this.isDarkMode ? 'darken-5' : 'lighten-5'
    },
    defaultActiveClass() {
      return `${this.color} ${this.colorClassModifier}`
    },
    defaultHoverClass() {
      return `${this.color} ${this.colorClassModifier}`
    },
    hasCustomActiveClass() {
      return !!this.activeClass
    },
    hasCustomHoverClass() {
      return !!this.hoverClass
    },
    compHoverClass() {
      if (this.disableHover) return ''

      return this.hasCustomHoverClass ? this.hoverClass : this.defaultHoverClass
    },
    compActiveClass() {
      return this.hasCustomActiveClass
        ? this.activeClass
        : this.defaultActiveClass
    },
    commentType() {
      return this.type > -1
        ? this.$store?.state.comments.cached.allCommentTypes?.find(
            ({ id }) => id === this.type
          )?.description
        : ''
    },
  },
}
</script>

<template>
  <v-hover v-slot="{ hover }">
    <v-sheet
      :class="[
        active ? compActiveClass : '',
        hover ? compHoverClass : '',
        isSmallOrLower ? '' : 'd-flex',
        'rounded-lg px-4 py-3 align-center',
      ]"
      elevation="3"
    >
      <div class="d-flex flex-grow-1 align-top">
        <slot v-if="!hideAvatar" name="avatar">
          <CommentBaseAvatar
            :name="addedBy"
            :icon="avatarIcon"
            :color="avatarColor"
          />
        </slot>
        <div class="overflow-wrap-anywhere w-full">
          <slot>
            <div v-html="text"></div>
          </slot>

          <div class="d-flex justify-space-between items-center mt-8">
            <slot name="subtitle">
              <CommentBaseSubtitle> {{ subtitle }} </CommentBaseSubtitle>
            </slot>
            <p
              v-if="commentType && commentType.length"
              class="font-weight-light mb-0 opacity-7"
            >
              {{ commentType }}</p
            >
          </div>
        </div>
      </div>
      <div class="flex-shrink-1 text-right">
        <slot name="actions"></slot>
      </div>
    </v-sheet>
  </v-hover>
</template>

<style scoped>
.w-full {
  width: 100% !important;
}
</style>
